<template>
    <div class="app-logo"></div>
</template>
<script>
    export default {
        name: "AppLogo"
    };
</script>
<style lang='less'>
    .app-logo {
        line-height: 50px;
        height: 50px;
        overflow: hidden;
        white-space: nowrap;
        transition: padding .3s;
        text-align: center;
        background-color: #3c72ff;
        background-image: url(../../assets/menu/图.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
        margin-bottom: 16px;

        .app-logo-text {
            font-size: 14px;
            vertical-align: middle;
            color: #FFF;
            font-weight: bold;
        }

        .app-logo-icon {
            background: url(../../assets/sylogo.png);
            background-size: contain;
            height: 26px;
            width: 26px;
            display: inline-block;
            margin-right: 5px;
            transition: .3s;
            vertical-align: middle;
        }
    }

    .h-layout-sider-collapsed {
        .app-logo-text {
            display: none;
        }
    }
</style>
